(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-payment-methods', {
                parent: 'entity',
                url: '/type-payment-methods',
                data: {
                    authorities: [],
                    pageTitle: 'TypePaymentMethods'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-payment-methods/list/type-payment-methods.html',
                        controller: 'TypePaymentMethodsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS, access);
                }]
            });
    }
})();
